import React from "react";
import { LabelModes } from "../../../ui-components/molecules/labeled-inputs/labeledInput";
import {
    useFormikContext,
} from 'formik';
import XGSFormInput from "../../../ui-components/form/input/xgsFormInput";
import { Contact as ContactModel } from "../../../app/data/terminal-details/models";

interface ExecutiveContactDetailsProps {
    executive: string;
    required?: boolean;
    label?: string;
}

const ExecutiveContactDetails: React.FC<ExecutiveContactDetailsProps> = ({
    executive,
    label,
    required = true,
}) => {

    const { values, setFieldValue,handleBlur, setFieldTouched } = useFormikContext<ContactModel>();
    return (
        
            <div className="edit-flex-box">
                <XGSFormInput
                    type="text"
                    name={executive + "Name"}
                    required={required}
                    labelMode={LabelModes.column}
                    label={label + " Name"}
                />

                <div className="edit-flex-box__item">
                    <XGSFormInput
                        type="text"
                        name={executive + "Phone"}
                        label={label + " Phone"}
                        required={required}
                        className="width-50"
                        labelMode={LabelModes.column}
                        onBlur={async (e) => {
                            // First, let Formik handle the blur (for validation)
                            handleBlur(e);
                            const phoneFieldName = `${executive}Phone`;
                            setFieldTouched(phoneFieldName, true);

                            const phoneValue = values[phoneFieldName as keyof ContactModel];
                            if (phoneValue) {
                                const formattedPhone = phoneValue.formatPhone();
                                if (formattedPhone !== "") {
                                    await setFieldValue(phoneFieldName, formattedPhone);
                                    // Trigger validation after formatting
                                    setFieldTouched(phoneFieldName, true);
                                }
                            }
                        }} />
                    <XGSFormInput
                        type="text"
                        name={executive + "Email"}
                        label={label + " Email"}
                        required={required}
                        className="width-50"
                        labelMode={LabelModes.column}
                    />
                </div>
            </div>
        
    );
};

export default ExecutiveContactDetails;
